import { Controller } from "stimulus"
import domtoimage from 'dom-to-image';

export default class extends Controller {

  download(e) {
    e.preventDefault();
    const node = document.getElementById('jury-capture');
    const indice = node.dataset.indice;
    if (typeof gtag !== 'undefined') {
      gtag('event', 'statistics', {'event_label': `JURY ${indice}`});
    }
    const scroller = node.closest('.jury-stats-scroll');
    if (scroller) scroller.scrollLeft = 0;
    // Render at 2x for a crisp image (dom-to-image captures at CSS resolution
    // otherwise), and reset the `margin: 0 auto` centering that would shift
    // the content inside the canvas. PNG keeps text and flat colors sharp.
    const scale = 2;
    domtoimage.toPng(node, {
      bgcolor: '#fbfaf8',
      width: node.offsetWidth * scale,
      height: node.offsetHeight * scale,
      style: {
        margin: '0',
        transform: `scale(${scale})`,
        transformOrigin: 'top left'
      }
    })
    .then(function (dataUrl) {
        var link = document.createElement('a');
        var current_year = new Date().getFullYear();
        link.download = `statistique-jury-${indice}-bac-${current_year}-ifutur.png`;
        link.href = dataUrl;
        link.click();
    });
  };

  downloadRegion(e) {
    e.preventDefault();
    const node = document.getElementById('region-capture');
    const name = node.dataset.name;
    if (typeof gtag !== 'undefined') {
      gtag('event', 'statistics', {'event_label': `Région ${name}`});
    }
    domtoimage.toJpeg(node, { quality: 10 })
    .then(function (dataUrl) {
        var link = document.createElement('a');
        link.download = `statistique-region-${name}-bac-2022-ifutur.jpeg`;
        link.href = dataUrl;
        link.click();
    });
  }
}
